import { getUser } from './func';

// View state only: never retain comment text, private sources or server data.
const readers = new Map();
const keyFor = (entry, id) => `${getUser()?.id || 'guest'}:${entry}:${id}`;
export const reactionEntry = () => `${Date.now()}-${Math.random().toString(36).slice(2)}`;
export function readReactionReader(entry, id) {
  const value = readers.get(keyFor(entry, id));
  return value && Date.now() - value.updated < 30 * 60 * 1000 ? value : null;
}
export function saveReactionReader(entry, id, patch) {
  const key = keyFor(entry, id);
  readers.set(key, { ...readers.get(key), ...patch, updated: Date.now() });
  while (readers.size > 40) readers.delete(readers.keys().next().value);
}
